import './adaptiveactionsheet.css'

import {
    ActionSheet, ActionSheetContent,
} from '@progress/kendo-react-layout';
import { X } from 'phosphor-react-sc';
import { useEffect, useState } from 'react';
import { isAdaptiveActive } from '../../helpers/ElementHelpers';

export const AdaptiveActionSheet = () => {

    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState(null);
    const [data, setData] = useState<any>(null);
    const [items, setItems] = useState<any[]>([]);

    const onClose = () => {
        setOpen(false);
    };

    const onItemSelect = (e:any) => {
        setOpen(false);
        
        publishAdaptiveActionSheetResponseTopic({
            guid: data.guid,
            item: e
        });

        setData(null);
    };

    const onResize = () => {
        if (isAdaptiveActive()) return;
        setOpen(false);
    }

    useEffect(() => {
        window.addEventListener("resize", onResize);
        return (() => {
            window.removeEventListener("resize", onResize);
        })

    }, []);

    // todo: use AppStore value to set data if component is to be used

    return (
        <ActionSheet
            className="actionsheet"
            expand={open}
            title={<div className="k-d-grid grid-cols-fr-auto">
                <div style={{ fontSize: "1.25rem" }}>{title}</div>
                <div><X weight="bold" onClick={onClose} /></div>
            </div>}
            animation={true}
            position={"fullscreen"}
            onClose={onClose}>
            <ActionSheetContent>
                <ul className="k-list-ul">
                    {
                        items.map((item, index) => (
                            <li
                                key={index}
                                onClick={() => onItemSelect(item.source)}
                                className={`k-list-item ${getItemSelectedClassNames(item)}`}>
                                <span className="k-list-item-text">
                                    {item.title}
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </ActionSheetContent>
        </ActionSheet>
    )

    // todo: use AppStore value to set data if component is to be used
    /*
    function handleMessage(msg: string, data: any) {
        setData(data);
        const result:any[] = [];

        for (const item of data.data) {
            result.push({
                title: item[data.dataTitleField],
                source: item
            })
        }

        setTitle(data.title);
        setItems(result);
        setOpen(true);
    }
    */
    function getItemSelectedClassNames(item: any) {
        const selectedValue = data?.selectedValue;
        const itemValue = item.source[data?.dataValueField];

        if (!selectedValue || !itemValue) return "";
        if (selectedValue !== itemValue) return "";

        return "k-selected";
    }
}
